import { defineMessage } from 'services/localization';

export const messages = {
    emailSubmitterRequiredError: defineMessage('email_submitter_needs_to_be_set'),
    regularSubmitterRequiredError: defineMessage('submitter_needs_to_be_set'),
    externalSubmitterRequiredError: defineMessage('external_submitter_needs_to_be_set'),
    dextSubmitterRequiredError: defineMessage('dext_submitter_needs_to_be_set'),
    reqularOrExternalSubmitterRequiredError: defineMessage('at_least_one_submitter_needs_to_be_set'),
};
